import * as React from "react";

const LocationIcon = (props) => (
  <svg
    viewBox="0 0 21 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="M10.281.738C4.836.738.405 5.043.405 10.334c0 3.416 1.07 4.786 6.209 11.369.892 1.143 1.903 2.438 3.06 3.936a.767.767 0 0 0 .607.296c.24 0 .465-.11.608-.296 1.15-1.49 2.157-2.78 3.045-3.919 5.152-6.602 6.224-7.976 6.224-11.386 0-5.291-4.43-9.596-9.877-9.596Zm2.443 20.09c-.73.935-1.54 1.972-2.443 3.14a988.804 988.804 0 0 0-2.457-3.157c-4.999-6.404-5.9-7.557-5.9-10.477 0-4.477 3.75-8.12 8.357-8.12 4.608 0 8.357 3.643 8.357 8.12 0 2.914-.903 4.071-5.914 10.494Z"
      fill="currentColor"
    />
    <path
      d="M10.282 5.167c-2.933 0-5.318 2.318-5.318 5.168 0 2.849 2.385 5.167 5.318 5.167 2.932 0 5.318-2.318 5.318-5.167 0-2.85-2.386-5.168-5.318-5.168Zm0 8.858c-2.095 0-3.799-1.655-3.799-3.69 0-2.036 1.704-3.691 3.799-3.691 2.094 0 3.798 1.655 3.798 3.69 0 2.036-1.704 3.691-3.798 3.691Z"
      fill="currentColor"
    />
  </svg>
);

export default LocationIcon;
